<template>
  <div class="login-wrapper">
    <div class="login-main">
      <div class="login-form-container">
        <el-form class="login-form" ref="form">
          <div class="image-logo"></div>
          <div class="form-content">
            <div class="welcome-text">欢迎登录</div>
            <el-form-item class="form-item">
              <el-input 
                :prefix-icon="ElUser"
                placeholder="请输入帐号"
                v-model="eusername"
                @keyup.enter="enterkey('password')"
                ref="username"
                autocomplete="username">
              </el-input>
            </el-form-item>
            <el-form-item class="form-item">
              <el-input 
                :prefix-icon="ElLock"
                placeholder="请输入密码" 
                v-model="epassword"
                @keyup.enter="onSubmit"
                show-password 
                ref="password"
                autocomplete="current-password">
              </el-input>
            </el-form-item>
            <el-form-item class="button-container">
              <el-button 
                type="success"
                @click="onSubmit" 
                :disabled="btnstop">
                确定
              </el-button>
            </el-form-item>
          </div>
        </el-form>
        <!-- 添加登录状态判断 -->
        <div v-if="showWeChatLogin">
          <el-result
            title="使用企业微信授权登录"
          >
            <template #extra>
              <div>
                <el-button @click="handleHandAuth" class="auth-button">
                  授权登录
                </el-button>
              </div>
              <div>{{ errtext }}</div>
            </template>
          </el-result>
        </div>
      </div>
    </div>
    <div class="footer">
      Powered by xiangyan ©2025
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { resetRouter } from '../router'
import { toLogin } from '../axios/api'
import { rrr, cache } from '../js00'
import { User as ElUser, Lock as ElLock } from '@element-plus/icons-vue'
import { markRaw } from 'vue'
import WechatAuth from '../utils/wechatAuth'
import AccessDetector from '../utils/accessDetector'


export default {
  data () {
    return {
      ElUser: markRaw(ElUser), // 非响应式
      ElLock: markRaw(ElLock),
      eusername: '',
      epassword: '',
      token: '',
      stusr: '',
      loginuser: '',
      btnstop: false,
      et: 1,
      showWeChatLogin: false,
      accessSource: null,
      errtext: null
    }
  },
  mounted () {
    resetRouter()
    const r = {
      path: '/wellincenter',
      name: 'wellinCenter',
      component: () => import(`@/components/wellinCenter.vue`),
      children: []
    }
    this.$router.addRoute(r)
    this.loginuser = localStorage.getItem('user') || ''
    this.stusr = localStorage.getItem('ucode') || ''
    this.token = localStorage.getItem('token') || ''

    this.detectAccessSource()
  },
  methods: {
    ...mapMutations(['setuser']),

    // 检测访问来源
    detectAccessSource() {
      this.accessSource = AccessDetector.detect()
      if (AccessDetector.isWxWork() || AccessDetector.isWeChat()) {
        this.showWeChatLogin = true
      } else {
        this.showWeChatLogin = false
      }
    },
    handleHandAuth() {
      // 不传自定义 state，由 WechatAuth 内部生成合法格式
      WechatAuth.handAuth();
    },
    onSubmit () {
      this.btnstop = true
      // 登录失败超过5次
      if (this.et > 4) {
        // 通过缓存计算剩余时间
        const etn = cache.get('et')
        const etrt = cache.remainingTime('et')
        if (etn) {  
          this.$message.error(`登录失败次数过多，请${(etrt/60/1000).toFixed(2)}分钟后尝试`)
          this.btnstop = false
          return
        } else {
          this.et = 1
        }
      }
      
      if (this.eusername === '' || this.epassword === '') {
        this.$message('帐号或密码不能为空')
        this.btnstop = false
      } else {
        if (this.eusername !== this.loginuser) {
          this.loginuser = this.eusername
          this.stusr = 'u_' + String(rrr(1, 999999999))
          this.token = ''
        }
        let st = {
          'username': this.eusername,
          'password': this.epassword,
          'ucode': this.stusr,
          'token': this.token,
          'loginenter': true
        }
        toLogin(st).then(res => {
          if (res.code === 0) {
            if (res.token !== '') {
              this.token = res.token
              this.setuser({user: this.eusername, ucode: this.stusr, token: this.token})
            } else {
              this.loginuser = localStorage.getItem('user') || ''
              this.stusr = localStorage.getItem('ucode') || ''
              this.token = localStorage.getItem('token') || ''
            }
            this.btnstop = false
            const redirect = this.$route.query.redirect || '/wellincenter'
            this.$router.replace({
              path: redirect
            }).then(() => {
              // 路由跳转成功后强制刷新
              setTimeout(() => {
                window.location.reload(true)
              }, 100)
            }).catch(err => {
              this.et += 1
              if (this.et === 5) {
                cache.set('et', 'et', 5 * 60 * 1000)
              }
              this.btnstop = false
              this.$message.error(`异常，路由跳转失败：${err}`)
            })
          } else {
            this.et += 1
            if (this.et === 5) {
              cache.set('et', 'et', 5 * 60 * 1000)
            }
            this.btnstop = false
            this.$message.error(res.message || '登录失败')
            window.location.reload(true)
          }
        }).catch(err => {
          this.et += 1
          if (this.et === 5) {
            cache.set('et', 'et', 5 * 60 * 1000)
          }
          this.btnstop = false
          this.$message.error(err.message || '网络错误，请重试')
        })
      }
    },
    enterkey (e) {
      this.$refs[e].focus()
    }
  }
}
</script>

<style scoped>
.login-wrapper {
  width: 100%;
  height: 100vh;
  background-image: url(/static/pictures/login.png);
  background-repeat: repeat; /* 平铺 */
  background-size: cover; /* 自动缩放适应页面大小 */
  background-position: center;
  background-color: white;
  position: relative;
  display: flex;
  flex-direction: column;
}

.login-main {
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-form-container {
  width: 100%;
  max-width: 450px;
  min-width: 300px;
  background-color: rgb(255, 255, 255);
  padding: 60px 60px 40px 60px;
  border-radius: 15px;
  box-shadow: 10px 10px 10px 0px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.login-form {
  width: 100%;
}

.image-logo {
  width: 200px;
  height: 68px;
  background-image: url(/static/pictures/logo0.png);
  background-position: 30% 30%;
  background-repeat: no-repeat;
  background-size: contain;
  margin-bottom: 30px;
  margin: 0 auto 30px auto;
}

.form-content {
  font-size: 16px;
}

.welcome-text {
  font-size: 18px;
  text-align: center;
  color: rgb(60, 60, 60);
  padding: 0 0 20px 0;
  font-weight: 500;
}

.form-item {
  margin-bottom: 20px;
}

.button-container :deep(.el-form-item__content) {
  display: flex;
  justify-content: center;
}

.button-container .el-button {
  background-color: #467D58;
  border-color: #467D58;
  color: white;
  width: 100%;
  max-width: 60px;
}

/* 按钮悬停效果 */
.button-container .el-button:hover {
  background-color: #3a6548;
  border-color: #3a6548;
}

/* 按钮禁用状态 */
.button-container .el-button.is-disabled {
  background-color: #a0cfb0;
  border-color: #a0cfb0;
}

.footer {
  width: 100%;
  text-align: center;
  color: gray;
  font-size: 12px;
  padding: 20px 0;
}

/* 修改账号密码输入框的默认底色 */
.form-item :deep(.el-input__wrapper) {
  background-color: #C8C9CA !important;
  box-shadow: 0 0 0 1px #C8C9CA inset !important; /* 同时修改边框颜色 */
}

/* 修改输入文字颜色（确保可读性） */
.form-item :deep(.el-input__inner) {
  color: #323232 !important;
}

/* 修改占位符文字颜色 */
.form-item :deep(.el-input__inner::placeholder) {
  color: #323232 !important;
}

/* 修改图标颜色 */
.form-item :deep(.el-input__prefix .el-icon) {
  color: #323232 !important;
}

/* 修改查看密码图标颜色 */
.form-item :deep(.el-input__suffix-inner .el-icon) {
  color: #323232 !important;
}

/* 悬停状态 */
.form-item :deep(.el-input__wrapper:hover) {
  background-color: #C8C9CA !important;
  box-shadow: 0 0 0 1px #C8C9CA inset !important;
}

/* 获得焦点状态 */
.form-item :deep(.el-input__wrapper.is-focus) {
  background-color: #C8C9CA !important;
  box-shadow: 0 0 0 1px #467D58 inset !important; /* 聚焦时边框变绿色 */
}

/* 鼠标悬停效果 */
.auth-button:hover {
  color: #467D58 !important;
  border-color: #467D58 !important;
}

/* 点击效果 */
.auth-button:active {
  color: #2e523a !important;
  border-color: #2e523a !important;
}

@media (max-width: 768px) {
  .login-wrapper {
    height: auto;
    min-height: 100vh;
    background-size: cover;
    background-attachment: fixed; /* 固定背景保持效果 */
  }

  .login-form-container {
    width: 80%;
    min-width: unset;
    max-width: 400px;
    padding: 50px 50px;
    margin: 40px auto;
  }
  
  .image-logo {
    height: 68px;
    margin-bottom: 20px;
  }

  .button-container .el-button {
    max-width: 100%;
  }
  
  .footer {
    padding: 15px 0;
  }
}
</style>